<template>
  <div id="app">
    <router-view/>
    <!-- <div class="pc ipad phone">
      <div class="box1"></div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  /* css3
  @media only screen and (min-width: 1000px) {
    .pc{
      border: 1px solid red;
    }
    .pc .box1{
      color:chartreuse
    }
  }
  @media screen and (min-width: 400px) and (max-width:1000px) {
    .ipad{
      border: 1px solid blue;
    }
    .ipad .box1{
      color:darkgoldenrod
    }
  }
  @media screen and (max-width:400px) {
    .phone{
      border: 1px solid black;
    }
    .phone .box1{
      color:darkred
    }
  } */
  li{
    list-style: none;
  }
  a{
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue